export const SIGNATURE_WARNINGS = {
  html_lint_errors: {
    id: 'html_lint_errors',
    icon: 'code',
    iconSize: 7,
    label: 'label.HTML_ERRORS',
    tooltip: 'label.TOOLTIP.HTML_ERRORS',
    color: '#ff0090'
  },
  images_without_src: {
    id: 'images_without_src',
    icon: 'image',
    iconSize: 9,
    label: 'label.IMAGES_WITHOUT_SRC',
    tooltip: 'label.TOOLTIP.IMAGES_WITHOUT_SRC',
    color: 'var(--color-red-300)'
  },
  images_without_inline: {
    id: 'images_without_inline',
    icon: 'image',
    iconSize: 9,
    label: 'label.IMAGES_WITHOUT_INLINE',
    tooltip: 'label.TOOLTIP.IMAGES_WITHOUT_INLINE',
    color: '#efb313'
  },
  missing_params: {
    id: 'missing_params',
    icon: 'triangle-alert',
    iconSize: 8,
    tooltip: 'label.TOOLTIP.MISSING_FIELDS',
    label: 'label.MISSING_FIELDS',
    color: 'var(--color-red-300)'
  },
  non_secure_urls: {
    id: 'non_secure_urls',
    icon: 'lock-open',
    iconSize: 8,
    label: 'label.NON_SECURE_URLS',
    tooltip: 'label.TOOLTIP.NON_SECURE_URLS',
    color: 'var(--color-red-500)'
  },
  smart_domain_mismatch: {
    id: 'smart_domain_mismatch',
    icon: 'globe',
    iconSize: 9,
    label: 'label.SMART_DOMAIN_URL_MISMATCH',
    tooltip: 'label.TOOLTIP.SMART_DOMAIN_URL_MISMATCH',
    color: 'var(--color-red-400)'
  },
  third_party_urls: {
    id: 'third_party_urls',
    icon: 'link-2',
    iconSize: 9,
    label: 'label.THIRD_PARTY_URLS',
    color: '#efb313'
  },
  unused_params: {
    id: 'unused_params',
    icon: 'server',
    iconSize: 9,
    label: 'label.UNUSED_FIELDS',
    tooltip: 'label.TOOLTIP.UNUSED_FIELDS',
    color: 'var(--color-gray-600)'
  }
};

export const SIGNATURE_BUILTIN_PARAMS = [
  'sgcname',
  'sgcnameproto',
  'sgsender',
  'sgrecipient',
  'sgsdomain',
  'sgrdomain',
  'sgsusername',
  'sgrusername',
  'sgrandom',
  'sgmsgid',
  'sgmsghashid',
  'sgsubject',
  'sginternal',
  'sgonlyinternal',
  'sgexternal'
];
